module.exports = __webpack_public_path__ + "static/media/Winged Star_1c2.74ba80d4.svg";